/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The direction the belt chevrons point.
 */
export const FlowDirection = {
  Ltr: "ltr",
  Rtl: "rtl",
} as const;
/**
 * The direction the belt chevrons point.
 */
export type FlowDirection = OpenEnum<typeof FlowDirection>;

/**
 * The configuration of the animatic for a belt conveyor. State and labels are carried by the animatic primitive states and animatic labels, not here.
 */
export type AnimaticBeltConveyorConfig = {
  /**
   * The direction the belt chevrons point.
   */
  flowDirection?: FlowDirection | undefined;
  /**
   * The belt incline in degrees; negative values raise the left end.
   */
  incline?: number | undefined;
  /**
   * The flat belt pulley-center span in viewBox units.
   */
  length?: number | undefined;
};

/** @internal */
export const FlowDirection$inboundSchema: z.ZodType<
  FlowDirection,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(FlowDirection);
/** @internal */
export const FlowDirection$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  FlowDirection
> = openEnums.outboundSchema(FlowDirection);

/** @internal */
export const AnimaticBeltConveyorConfig$inboundSchema: z.ZodType<
  AnimaticBeltConveyorConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  flow_direction: types.optional(FlowDirection$inboundSchema),
  incline: types.optional(types.number()),
  length: types.optional(types.number()),
}).transform((v) => {
  return remap$(v, {
    "flow_direction": "flowDirection",
  });
});
/** @internal */
export type AnimaticBeltConveyorConfig$Outbound = {
  flow_direction?: string | undefined;
  incline?: number | undefined;
  length?: number | undefined;
};

/** @internal */
export const AnimaticBeltConveyorConfig$outboundSchema: z.ZodType<
  AnimaticBeltConveyorConfig$Outbound,
  z.ZodTypeDef,
  AnimaticBeltConveyorConfig
> = z.object({
  flowDirection: FlowDirection$outboundSchema.optional(),
  incline: z.number().optional(),
  length: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    flowDirection: "flow_direction",
  });
});

export function animaticBeltConveyorConfigToJSON(
  animaticBeltConveyorConfig: AnimaticBeltConveyorConfig,
): string {
  return JSON.stringify(
    AnimaticBeltConveyorConfig$outboundSchema.parse(animaticBeltConveyorConfig),
  );
}
export function animaticBeltConveyorConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticBeltConveyorConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticBeltConveyorConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticBeltConveyorConfig' from JSON`,
  );
}
